import React from 'react';
import EditFighter from './EditFighter';

const EditFighterPage = () => {
    return <EditFighter />;
};

export default EditFighterPage;